interface Image {
  alt: string;
  src: string;
}

interface Accolades {
  id: number;
  image: Image;
}

export const APPS_DATA: Accolades[] = [
  {
    id: 0,
    image: {
      alt: 'Natural Cycles',
      src: 'developer/logo-natural-cycles.png',
    },
  },
  {
    id: 1,
    image: {
      alt: 'Wild',
      src: 'developer/logo-wild.png',
    },
  },
  {
    id: 2,
    image: {
      alt: 'Zero',
      src: 'developer/logo-zero.png',
    },
  },
  {
    id: 3,
    image: {
      alt: 'Cronometer',
      src: 'developer/logo-cronometer.png',
    },
  },
];
